var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.456 3.76988C19.556 2.86988 18.366 2.37988 17.096 2.37988C15.826 2.37988 14.636 2.86988 13.736 3.76988L4.26599 13.2399C3.87599 13.6299 3.61599 14.1099 3.51599 14.6499L2.51599 19.6599C2.39599 20.2399 2.57599 20.8299 2.99599 21.2399C3.32599 21.5699 3.77599 21.7499 4.23599 21.7499C4.34599 21.7499 4.46599 21.7399 4.57599 21.7199L9.58599 20.7199C10.116 20.6099 10.606 20.3499 10.996 19.9699L20.466 10.4999C21.366 9.59988 21.856 8.40988 21.856 7.13988C21.856 5.86988 21.366 4.67988 20.466 3.77988L20.456 3.76988ZM4.27599 20.2399C4.16599 20.2599 4.08599 20.2099 4.04599 20.1699C4.00599 20.1299 3.95599 20.0599 3.97599 19.9399L4.82599 15.7099L8.50599 19.3899L4.27599 20.2399ZM19.396 9.42988L10.026 18.7999L5.42599 14.1999L14.796 4.82988C15.426 4.19988 16.266 3.87988 17.096 3.87988C17.926 3.87988 18.756 4.19988 19.396 4.82988C20.666 6.09988 20.666 8.15988 19.396 9.42988Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.d2df8490037c8054a7aa61d3728fb336.svg";
export { ForwardRef as ReactComponent };